import React, { useState } from 'react';
import Icon from '../../Icon';
import clsx from 'clsx';
import { translate } from '../../../Services/translation';

const DescriptionCollapsible = ({ label, content, icon }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleCollapsible = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="description-collapsible">
      <button
        className="description-collapsible__header"
        aria-expanded={isOpen}
        aria-label={translate(
          isOpen
            ? 'product.descriptioncollapsible.expanded.sc'
            : 'product.descriptioncollapsible.hidden.sc'
        )}
        onClick={toggleCollapsible}
      >
        <Icon name={icon} size={24} className="description-collapsible__icon" />
        <div className="description-collapsible__label">{label}</div>
        <Icon
          name="Caret-Down"
          size={24}
          className={clsx(
            'description-collapsible__toggle-icon',
            isOpen ? 'open' : ''
          )}
        />
      </button>
      {isOpen && (
        <div className="description-collapsible__content" aria-hidden={!isOpen}>
          {content}
        </div>
      )}
    </div>
  );
};

export default DescriptionCollapsible;
